import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("vinculo_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vinculo_token", data.token);
    localStorage.setItem("vinculo_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("vinculo_token", data.token);
    localStorage.setItem("vinculo_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("vinculo_token");
    localStorage.removeItem("vinculo_user");
    setUser(null);
    window.location.href = "/";
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("vinculo_user", JSON.stringify(data));
      setUser(data);
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    if (localStorage.getItem("vinculo_token") && !user) {
      refresh();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
